import List from "@/components/list";
//import Bus from "./Bus.js";
import router from "@/router";

const Table = args => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};
  const deleteAudio = args.listeners["deleteAudio"] || function() {};


  const Deal = ({ props: { vo } }) => {
    const audio = vo.row;
    //const canOnline = audio.onlineStatus == 0;
    const canNotEdit = audio.onlineStatus == 1;
    const dealConf = [
      [
        canNotEdit ? "icon-edit-disable" : "icon-edit",
        "编辑",
        canNotEdit
          ? () => {}
          : () => {
              router.push({ path: "/audio/edit", query: { id: audio.uuid } });
            },
        "audio:update"
      ] /*,
      [
        canOnline ? "icon-delete" : "icon-delete-disable",
        "删除",
        canOnline ? () => deleteAudio(audio.uuid) : () => {},
        "audio:delete"
      ]*/
    ];

    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const AudioSetName = ({ props: { vo } }) => {
    return <span>{vo.row.audioSetName || "--"}</span>;
  };
  const DeptName = ({ props: { vo } }) => {
    return <span>{vo.row.deptName || "--"}</span>;
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main"
    },
    {
      label: "音频名称",
      prop: "audioName",
      minWidth: "150",
      fixed: "left",
      showOverflowTooltip: true,
      render: vo => (
        <el-button
          class="no-padding"
          size="small"
          type="text"
          onClick={() => {
            router.push({
              path: "/audio/details",
              query: { id: vo.row.uuid }
            });
          }}
        >
          {vo.row.audioName}
        </el-button>
      )
    },
    {
      label: "所属音频集",
      prop: "audioSetName",
      minWidth: "150",
      render: (vo) => <AudioSetName vo={vo} />,
      showOverflowTooltip: true
    },
    {
      label: "音频时长",
      prop: "audioFormat",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "播放量",
      prop: "playNum",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "120",
      showOverflowTooltip: true
    },

    {
      label: "所属部门",
      prop: "deptName",
      width: "120",
      render: (vo) => <DeptName vo={vo} />,
      showOverflowTooltip: true
    },
    {
      label: "操作",
      minWidth: "80",
      align: "center",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];

  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
